import { useMutation } from 'react-query';
import { network } from 'services/network';
import { Version } from 'components/common/UploadFileModal/components/programLibrary.types';

const mutationFn = (params) => {
    const data = new FormData();
    data.append('file', params.file, params.fileName);

    const payload: any = {
        projectId: params.projectId,
        contractId: params.contractId,
        isBaseline: params.isBaseline,
        contractName: params.contractName,
        versionId: params.versionId,
        uploadingUser: params.uploadingUser,
        versions: params.versions,
        language: params.language,
        mppACEnabled: params.isTransformMPP,
    };

    if (params.plf_file) {
        data.append('plf_file', params.plf_file, params.plf_file.name);
    }

    if (params.anotherFile) {
        data.append('plf_file', params.anotherFile, params.anotherFile.name);
    }

    if (params.versionName) {
        payload.versionName = params.versionName;
    }

    if (params.versionDate) {
        payload.versionDate = params.versionDate;
    }

    data.append('request', JSON.stringify(payload));

    return network
        .post('api/bo/uploadXerFileVersions', data, {
            transformRequest: [
                (data, headers) => {
                    if (headers) {
                        headers['Content-Type'] = 'multipart/form-data';
                    }
                    return data;
                },
            ],
        })
        .then(() => {
            return true;
        });
};
export const useMutationUploadXerFile = () => {
    return useMutation<any, QueryError, UploadXerPayload>({ mutationFn: (params) => mutationFn(params) });
};

export interface UploadXerPayload {
    projectId: number;
    contractId: number | null;
    contractName: string;
    versionId: string[];
    uploadingUser: string;
    isBaseline: boolean[];
    file: Blob;
    plf_file?: File | null;
    anotherFile?: File | null;
    versionName?: string;
    versionDate?: string;
    fileName: string;
    versions: Version[];
}
